import { Injectable } from "@angular/core";
import { BehaviorSubject, of } from "rxjs";
import { AuthService } from "~app/auth/auth.service";
import { ILayer } from "../../layer/layer.type";
import { MarkerMode } from "../../map.service";

@Injectable({
  providedIn: 'root',
})
export class MapSettingsService {
  public flagLayerFilter = new BehaviorSubject<boolean>(false);
  public flagLayerFilter$ = this.flagLayerFilter.asObservable();

  public canvasLayers = new BehaviorSubject<ILayer[]>(this.authService.getTenantConfig(MarkerMode.Canvas).layerDefinitions);

  public layersLoaded = new BehaviorSubject<boolean>(false);
  public layersLoaded$ = this.layersLoaded.asObservable();

  constructor(
    private readonly authService: AuthService) {
  }
}
